import { Stack, Typography } from "@schaeffler-commerce/design-system";

export const StepHeader = ({ title, subtitle }: { title: string; subtitle: string }) => {
  return (
    <Stack sx={{
      gap: 2
    }}>
      <Typography variant="headlineLarge" align="center">
        {title}
      </Typography>

      <Typography variant="bodyLarge" align="center" color="textLabel">
        {subtitle}
      </Typography>
    </Stack>
  );
};
